import type { DemoKey } from '../../types';

export interface BivariatePoint {
  x: number;
  y: number;
  confounder?: string | number;
}

export interface BivariateDataset {
  id: string;
  labelKey: DemoKey;
  descKey: DemoKey;
  xLabelKey: DemoKey;
  yLabelKey: DemoKey;
  confounderLabelKey?: DemoKey;
  points: readonly BivariatePoint[];
}

export const ICE_CREAM_VS_DROWNINGS: BivariateDataset = {
  id: 'spurious-ice-cream-vs-drownings',
  labelKey: 'dataset.spurious-ice-cream-vs-drownings.label',
  descKey: 'dataset.spurious-ice-cream-vs-drownings.desc',
  xLabelKey: 'column.ice-cream-sales.label',
  yLabelKey: 'column.drownings.label',
  confounderLabelKey: 'column.month.label',
  points: [
    { x: 1.0, y: 1, confounder: 'Jan' },
    { x: 1.2, y: 2, confounder: 'Feb' },
    { x: 2.0, y: 4, confounder: 'Mar' },
    { x: 3.5, y: 7, confounder: 'Apr' },
    { x: 5.5, y: 12, confounder: 'May' },
    { x: 8.0, y: 18, confounder: 'Jun' },
    { x: 9.5, y: 22, confounder: 'Jul' },
    { x: 9.0, y: 20, confounder: 'Aug' },
    { x: 6.5, y: 14, confounder: 'Sep' },
    { x: 4.0, y: 8, confounder: 'Oct' },
    { x: 2.5, y: 4, confounder: 'Nov' },
    { x: 1.5, y: 2, confounder: 'Dec' },
  ],
};

export const STORKS_VS_BIRTHS: BivariateDataset = {
  id: 'spurious-storks-vs-births',
  labelKey: 'dataset.spurious-storks-vs-births.label',
  descKey: 'dataset.spurious-storks-vs-births.desc',
  xLabelKey: 'column.storks.label',
  yLabelKey: 'column.births.label',
  confounderLabelKey: 'column.country_area_km2.label',
  points: [
    { x: 100, y: 83, confounder: 28748 },
    { x: 300, y: 87, confounder: 30528 },
    { x: 1000, y: 118, confounder: 41526 },
    { x: 5000, y: 230, confounder: 78867 },
    { x: 9000, y: 367, confounder: 110994 },
    { x: 11000, y: 439, confounder: 132000 },
    { x: 18000, y: 774, confounder: 244820 },
    { x: 25000, y: 901, confounder: 312685 },
    { x: 30000, y: 1576, confounder: 504000 },
    { x: 42000, y: 1879, confounder: 549944 },
    { x: 50000, y: 2049, confounder: 593000 },
    { x: 90000, y: 4413, confounder: 1209000 },
  ],
};

export const SPURIOUS_PRESETS = [ICE_CREAM_VS_DROWNINGS, STORKS_VS_BIRTHS] as const;
